import * as React from 'react';
import { useHistory } from 'react-router';
import { DropdownItem } from 'reactstrap';
import { INavigationLinkProps } from '../types';

export const NavigationItem = ({ routePath, navTitle }: INavigationLinkProps) => {
  const history = useHistory();
  const historyRedirect = React.useCallback((path: string) => history.replace(path, {}), [])
  return (
    <DropdownItem onClick={() => historyRedirect(routePath)}>
      {navTitle}
    </DropdownItem>
  )
}
